import { replace } from "lodash";
import numeral from "numeral";

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(
    Number.isInteger(number) ? "$0,0.00" : "$0,0.00",
  );
}

export function fFloat(number) {
  return numeral(number).format(Number.isInteger(number) ? "0,0.00" : "0,0.00");
}
export function fFloatWithoutComma(number) {
  return numeral(number).format(Number.isInteger(number) ? "00.00" : "00.00");
}

export function fPercent(number) {
  return numeral(number / 100).format("0.0%");
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format("0.00a"), ".00", "");
}
export function fShortenNumberRoundOffTwo(number) {
  return replace(numeral(number).format("0.00"), ".00", "");
}
export function fData(number) {
  return numeral(number).format("0.0 b");
}

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}
